module.exports = __webpack_public_path__ + "static/media/552.ee532a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/552.png
// module id = 769
// module chunks = 0